import {
  FormLayout,
  LoadingButton,
  PageLayout,
  InputControl,
} from 'components/custom';
import { Form } from 'components/shadcn';
import { version } from '../../../../package.json';
import { usePageSignIn } from '../hooks';

export const PageSignIn = () => {
  const { state, form, onSubmit } = usePageSignIn();
  return (
    <PageLayout>
      <FormLayout>
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className="p-6 md:p-8 h-[350px] flex items-center justify-center"
          >
            <div className="flex flex-col space-y-6 w-full">
              <div className="flex flex-col items-center text-center">
                <h1 className="text-2xl font-bold">Welcome to bfitds</h1>
              </div>
              <InputControl
                form={form}
                type="text"
                label="Player Code"
                name="playerCode"
                placeholder="Please enter your player code to continue"
              />

              <LoadingButton
                loading={state.isSubmitting}
                type="submit"
                className="w-full"
              >
                Continue
              </LoadingButton>
              <div className="text-center text-sm text-muted-foreground">
                v{version}
              </div>
            </div>
          </form>
        </Form>
      </FormLayout>
    </PageLayout>
  );
};
